// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MonitorUI_view__kWU3f {
  position: relative;
  padding-bottom: 80px;
}

.MonitorUI_loader__38pBI {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.MonitorUI_history__LK8dl {
  background-color: #fff;
  border-radius: 4px;
  border: 0.5px solid var(--gray);
  padding: 6px 15px;
  display: flex;
  align-items: center;
}

.MonitorUI_history__LK8dl span {
  margin-top: 2px;
  margin-left: 10px;
  color: var(--darkGray);
  font-weight: 500;
}

.MonitorUI_eye__OqweZ {
  background-color: transparent;
  color: var(--orange);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  cursor: pointer;
}

/* .eye svg {
  width: 22px;
  height: 22px;
}
 */

.MonitorUI_warning__eeP6r {
  color: red;
  margin-right: 8px;
  margin-bottom: -2px;
}

.MonitorUI_ordersButtons__oQVtC{
  display: flex;
  gap: 1rem
}

.MonitorUI_containerIconViews__nWmL1{
  display: flex;
  justify-content: flex-end;
}

.MonitorUI_icons__DV4LM{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
  width: 112px;
  height: 40px;
  border: 1px solid #AEAEAE;
  border-radius: 6px;
  gap:20px;
}

.MonitorUI_icons__DV4LM > *{
  cursor: pointer;
}

.MonitorUI_containerStates__0V\\+9A{
  display: flex;
  gap:20px;
  flex-wrap: wrap;
  margin:20px 0px;
}

.MonitorUI_state__Tb3pB{
  width: 150px;
  height: 36px;
  border-radius: 30px;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 10px;
  font-weight: 500;
  cursor: pointer;
}

.MonitorUI_stateInactive__mI17h{
  background-color: #E6E6E6;
  color:#878787;
}

.MonitorUI_stateActive__Kh4rq{
  background-color: var(--orange);
  color:#fff;
}

.MonitorUI_badge__y4-aW{
  width: 25px;
  height: 25px;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.MonitorUI_badgeInactive__Uytio{
  background-color: #ABABAB;
  color:#fff;
}

.MonitorUI_badgeActive__2gg4m{
  background-color: #fff;
  color:#9E3223;
}

.MonitorUI_containerOrders__W-LL3{
  display: flex;
  gap:20px;
  flex-wrap: wrap;
  margin-top: 20px;
}

.MonitorUI_order__PqB63{
  width: 347px;
  height: 100%;
  box-shadow: 0px 2px 15px 0px #64646426;
  border-radius: 8px;
  padding: 10px;
  background-color: #fff;
}

.MonitorUI_header__ZimPh {
  border-radius: 8px;
  padding: 2px;
  background: #F5F5F5;
}

.MonitorUI_header__ZimPh p {
  margin: 0px;
}

.MonitorUI_ticketCreated__kWlZA{
  display: flex;
  justify-content: space-between;
}

.MonitorUI_ticket__qP4e4 {
  font-weight: 400;
  font-size: 15px;
  color: #444444;
}

.MonitorUI_created__z2vrn{
  font-weight: 600;
  font-size: 18px;
  color: var(--orange);
}

.MonitorUI_typeOrder__3-JuP {
  text-align: center;
  font-weight: 600;
  font-size: 18px;
}

.MonitorUI_orderDetail__yUsOz{
  display: flex;
  gap:10px;
  margin-top: 10px;
}

.MonitorUI_orderItem__1OBqC p {
  margin: 2px;
}

.MonitorUI_orderItemTitle__X9oit{
  font-size: 12px;
  font-weight: 400;
  line-height: 14.06px;
  color: #383838;
}

.MonitorUI_orderItemValue__WbJtH{
  font-size: 16px;
  font-weight: 400;
  line-height: 18.75px;
  color: #444444;
}

.MonitorUI_telephoneClock__blnK\\+{
  display: flex;
  justify-content: space-between;
}

.MonitorUI_moreDetail__rwj46{
  display: flex;
  flex-wrap: wrap;
  gap:10px;
  margin-top: 20px;
}

.MonitorUI_labelItemBox__JDhVj{
  display: flex;
  flex-direction: column;
  align-items: center;
}

.MonitorUI_label__QTCH\\+{
  font-size: 12px;
  font-weight: 400;
  color:#383838;
  margin: 0px;
}

.MonitorUI_itemBox__GG5J1 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 94px;
  height: 76px;
  border-radius: 8px;
  border: 1px solid #BFBFBF;
  background: #F5F5F5;
}

.MonitorUI_total__4tckf {
  font-size: 20px;
  font-weight: 600;
  color: var(--orange);
}

@media screen AND (max-width: 720px) {
  .MonitorUI_ordersButtons__oQVtC{
    flex-direction: column;
  }
}

.MonitorUI_helloFrameVisible__KiIcl {
  position: relative;
  width: 100%;
  height: calc(100vh - 180px);
  margin-top: 12px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0,0,0,0.08);
}

.MonitorUI_tabs__lAnJE .ant-tabs-nav-operations {
  display: none !important;
}

.MonitorUI_helloFrameVisible__KiIcl > iframe {
  width: 100%;
  height: 100%;
  border: 0;
}

.MonitorUI_helloFrameHidden__YgDpQ {
  position: fixed;
  bottom: -10000px;
  right: -10000px;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
  z-index: -1;
}

.MonitorUI_helloFrameHidden__YgDpQ > iframe {
  width: 1px;
  height: 1px;
  border: 0;
}

`, "",{"version":3,"sources":["webpack://./src/pages/monitor/styles/MonitorUI.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;;;;EAIE;;AACF;EACE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb;AACF;;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACC,yBAAyB;EACzB,aAAa;AACd;;AAEA;EACE,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AACA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AACA;EACE,WAAW;AACb;;AAGA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAEhB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AAEtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAGA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAGA;EACE,WAAW;AAEb;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AACA;EACC,aAAa;EACb,8BAA8B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AAErB;;AAEC;EACC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,WAAW;AAEb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;AACzC;;AACA;EACE,wBAAwB;AAC1B;;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,SAAS;AACX","sourcesContent":[".view {\n  position: relative;\n  padding-bottom: 80px;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.history {\n  background-color: #fff;\n  border-radius: 4px;\n  border: 0.5px solid var(--gray);\n  padding: 6px 15px;\n  display: flex;\n  align-items: center;\n}\n\n.history span {\n  margin-top: 2px;\n  margin-left: 10px;\n  color: var(--darkGray);\n  font-weight: 500;\n}\n\n.eye {\n  background-color: transparent;\n  color: var(--orange);\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  cursor: pointer;\n}\n\n/* .eye svg {\n  width: 22px;\n  height: 22px;\n}\n */\n.warning {\n  color: red;\n  margin-right: 8px;\n  margin-bottom: -2px;\n}\n\n.ordersButtons{\n  display: flex;\n  gap: 1rem\n}\n.containerIconViews{\n  display: flex;\n  justify-content: flex-end;\n}\n\n.icons{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 5px;\n  width: 112px;\n  height: 40px;\n  border: 1px solid #AEAEAE;\n  border-radius: 6px;\n  gap:20px;\n}\n\n.icons > *{\n  cursor: pointer;\n}\n\n.containerStates{\n  display: flex;\n  gap:20px;\n  flex-wrap: wrap;\n  margin:20px 0px;\n}\n\n.state{\n  width: 150px;\n  height: 36px;\n  border-radius: 30px;\n  text-transform: uppercase;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  font-size: 10px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.stateInactive{\n background-color: #E6E6E6;\n color:#878787;\n}\n\n.stateActive{\n  background-color: var(--orange);\n  color:#fff;\n}\n\n.badge{\n  width: 25px;\n  height: 25px;\n  border-radius: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.badgeInactive{\n  background-color: #ABABAB;\n  color:#fff;\n}\n.badgeActive{\n  background-color: #fff;\n  color:#9E3223;\n}\n\n.containerOrders{\n  display: flex;\n  gap:20px;\n  flex-wrap: wrap;\n  margin-top: 20px;\n}\n\n.order{\n  width: 347px;\n  height: 100%;\n  box-shadow: 0px 2px 15px 0px #64646426;  \n  border-radius: 8px;\n  padding: 10px;\n  background-color: #fff;\n}\n\n.header {\n  border-radius: 8px;\n  padding: 2px;\n  background: #F5F5F5;\n}\n.header p {\n  margin: 0px;\n}\n\n\n.ticketCreated{\n  display: flex;\n  justify-content: space-between;\n}\n\n.ticket {\n  font-weight: 400;\n  font-size: 15px;\n  color: #444444;\n\n}\n\n.created{\n  font-weight: 600;\n  font-size: 18px;\n  color: var(--orange);\n\n}\n\n.typeOrder {\n  text-align: center;\n  font-weight: 600;\n  font-size: 18px;\n}\n\n\n.orderDetail{\n  display: flex;\n  gap:10px;\n  margin-top: 10px;\n}\n\n\n.orderItem p {\n  margin: 2px;\n\n}\n.orderItemTitle{\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14.06px;\n  color: #383838;\n}\n\n.orderItemValue{\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 18.75px;\n  color: #444444;\n}\n.telephoneClock{\n display: flex;\n justify-content: space-between;\n}\n\n.moreDetail{\n  display: flex;\n  flex-wrap: wrap;\n  gap:10px;\n  margin-top: 20px;\n}\n\n\n\n.labelItemBox{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n}\n\n .label{\n  font-size: 12px;\n  font-weight: 400;\n  color:#383838;\n  margin: 0px;\n\n}\n\n.itemBox {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 94px;\n  height: 76px;\n  border-radius: 8px;\n  border: 1px solid #BFBFBF;\n  background: #F5F5F5;\n}\n.total {  \n  font-size: 20px;\n  font-weight: 600;\n  color: var(--orange);\n}\n\n@media screen AND (max-width: 720px) {\n  .ordersButtons{\n    flex-direction: column;\n  }\n}\n.helloFrameVisible {\n  position: relative;\n  width: 100%;\n  height: calc(100vh - 180px);\n  margin-top: 12px;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.08);\n}\n.tabs :global(.ant-tabs-nav-operations) {\n  display: none !important;\n}\n.helloFrameVisible > iframe {\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.helloFrameHidden {\n  position: fixed;\n  bottom: -10000px; \n  right: -10000px;\n  width: 1px; \n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.helloFrameHidden > iframe {\n  width: 1px;\n  height: 1px;\n  border: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `MonitorUI_view__kWU3f`,
	"loader": `MonitorUI_loader__38pBI`,
	"history": `MonitorUI_history__LK8dl`,
	"eye": `MonitorUI_eye__OqweZ`,
	"warning": `MonitorUI_warning__eeP6r`,
	"ordersButtons": `MonitorUI_ordersButtons__oQVtC`,
	"containerIconViews": `MonitorUI_containerIconViews__nWmL1`,
	"icons": `MonitorUI_icons__DV4LM`,
	"containerStates": `MonitorUI_containerStates__0V+9A`,
	"state": `MonitorUI_state__Tb3pB`,
	"stateInactive": `MonitorUI_stateInactive__mI17h`,
	"stateActive": `MonitorUI_stateActive__Kh4rq`,
	"badge": `MonitorUI_badge__y4-aW`,
	"badgeInactive": `MonitorUI_badgeInactive__Uytio`,
	"badgeActive": `MonitorUI_badgeActive__2gg4m`,
	"containerOrders": `MonitorUI_containerOrders__W-LL3`,
	"order": `MonitorUI_order__PqB63`,
	"header": `MonitorUI_header__ZimPh`,
	"ticketCreated": `MonitorUI_ticketCreated__kWlZA`,
	"ticket": `MonitorUI_ticket__qP4e4`,
	"created": `MonitorUI_created__z2vrn`,
	"typeOrder": `MonitorUI_typeOrder__3-JuP`,
	"orderDetail": `MonitorUI_orderDetail__yUsOz`,
	"orderItem": `MonitorUI_orderItem__1OBqC`,
	"orderItemTitle": `MonitorUI_orderItemTitle__X9oit`,
	"orderItemValue": `MonitorUI_orderItemValue__WbJtH`,
	"telephoneClock": `MonitorUI_telephoneClock__blnK+`,
	"moreDetail": `MonitorUI_moreDetail__rwj46`,
	"labelItemBox": `MonitorUI_labelItemBox__JDhVj`,
	"label": `MonitorUI_label__QTCH+`,
	"itemBox": `MonitorUI_itemBox__GG5J1`,
	"total": `MonitorUI_total__4tckf`,
	"helloFrameVisible": `MonitorUI_helloFrameVisible__KiIcl`,
	"tabs": `MonitorUI_tabs__lAnJE`,
	"helloFrameHidden": `MonitorUI_helloFrameHidden__YgDpQ`
};
export default ___CSS_LOADER_EXPORT___;
